export default __webpack_public_path__ + "static/media/orderPlaced.ec0084ba.gif";